import { Component, OnInit } from '@angular/core';
import { Auth } from '../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {
  //@HostBinding('class') className = 'main-container';

  constructor(public auth: Auth,
              public router: Router) {
  }

  ngOnInit() {
  }

  logout() {
    this.auth.logout().subscribe(() => {
      console.log('apa');
      this.router.navigate(['/login']);
    });
  }

  get currentUser() {
    return this.auth.user;
  }

}



// WEBPACK FOOTER //
// ./src/app/base/base.component.ts